var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("router-link", { attrs: { to: { name: "my-office" } } }, [
        _vm._v("Персональные данные"),
      ]),
      _vm._v(" "),
      _c("router-link", { attrs: { to: { name: "orders" } } }, [
        _vm._v("Заказы"),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }